import { theme } from 'antd';
import { ConfigTenant } from './tenant.config';
import { isLightTheme } from 'utils';

const getAntThemeConfig = (themeMode = 'light', tenantData = null) => {
  const colorPrimaryLight =
    tenantData?.style_sheet?.ant_variables?.primary_color_light ??
    ConfigTenant.data.color.ant_variables.primary_color_light;
  const colorSecondaryLight =
    tenantData?.style_sheet?.ant_variables?.secondary_color_light ??
    ConfigTenant.data.color.ant_variables.secondary_color_light;

  const colorPrimaryDark =
    tenantData?.style_sheet?.ant_variables?.primary_color_dark ??
    ConfigTenant.data.color.ant_variables.primary_color_dark;
  const colorSecondaryDark =
    tenantData?.style_sheet?.ant_variables?.secondary_color_dark ??
    ConfigTenant.data.color.ant_variables.secondary_color_dark;

  const isUseDarkTheme = !isLightTheme(themeMode);

  return {
    hashed: false,
    cssVar: { key: 'elevate' },
    algorithm: isUseDarkTheme ? theme.darkAlgorithm : theme.defaultAlgorithm,
    token: {
      fontFamily: `Urbanist, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'`,
      colorPrimary: isUseDarkTheme ? colorPrimaryDark : colorPrimaryLight,
      colorSecondary: isUseDarkTheme ? colorSecondaryDark : colorSecondaryLight,

      fontSize: 12, // Decrease the base font size
      padding: 8, // Reduce padding inside components
      // borderRadius: 4, // Adjust border radius for smaller UI elements
      fontSizeHeading1: 20, // Adjust heading sizes if necessary
      fontSizeHeading2: 16,

      ...(isUseDarkTheme
        ? {
            colorBgBase: '#161616',
            colorBgContainer: '#1F1F1F',
            colorBgElevated: 'var(--user-modal-bg)',
            colorBgMask: 'rgba(0, 0, 0, 0.6)',
          }
        : {}),
    },
    components: {
      Input: {
        algorithm: true,
      },
      Button: {
        defaultShadow: 'none',
        dangerShadow: 'none',
        primaryShadow: 'none',
        fontWeight: '600',
      },
      DatePicker: {
        sizePopupArrow: 0,
      },
      Collapse: {
        headerBg: '#fff',
      },
      Checkbox: {
        controlInteractiveSize: 20,
      },
    },
  };
};

export default getAntThemeConfig;
